import { Descriptions, Divider, Typography } from 'antd';

import { SALES_CHANNEL_TEXT } from '../const';
import { AdminOrderQuery } from '../graphql/order.generated';

type OrderDetailChannelProps = {
  order: AdminOrderQuery['adminOrder'];
};

export default function OrderDetailChannel({ order }: OrderDetailChannelProps) {
  const productName = order.salesChannelProductName || '-';

  return (
    <div>
      <Divider orientation='left' plain>
        <Typography.Title level={5} className='mb-0'>
          판매채널정보
        </Typography.Title>
      </Divider>
      <Descriptions
        bordered
        className='[&_.ant-descriptions-view]:rounded-none'
      >
        <Descriptions.Item
          label='판매채널'
          span={2}
          labelStyle={{ width: 200 }}
          contentStyle={{ width: 276 }}
        >
          {SALES_CHANNEL_TEXT[order.salesChannel]}
        </Descriptions.Item>
        <Descriptions.Item
          label='판매채널 상품명'
          labelStyle={{ width: 200 }}
          contentStyle={{ width: 276 }}
        >
          {productName}
        </Descriptions.Item>
        <Descriptions.Item label='판매채널 주문번호' span={2}>
          {order.group.salesChannelOrderGroupCode || '-'}
        </Descriptions.Item>
        <Descriptions.Item label='판매채널 상품주문번호'>
          {order.salesChannelOrderCode || '-'}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
}
